// ! v4.2.2服务商资料管理 新增/编辑
<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="small" @click="$router.go(-1)">返回</el-button>
      <span>编辑资料</span>
      <!-- <span>服务商首次维护</span> -->
    </div>
    <!-- end of title -->

    <el-form :model="formData" :rules="formRules" ref="formData" label-width="150px">
      <!-- start of 基础信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">基础信息</span>
        <div class="form-item-box">
          <el-row :gutter="24">   
            <el-col :span="12">
              <!-- 公司名称 -->
              <el-form-item label="公司名称" :show-message="false" prop="tenantSimpleAddDTO.tenantName">
                <el-input
                  clearable
                  :maxlength="50"
                  @blur="formData.tenantSimpleAddDTO.tenantName = $event.target.value.replace(/\s/g, '')"
                  placeholder="最多输入50个字"
                  size="small"
                  min="0"
                  v-model="formData.tenantSimpleAddDTO.tenantName"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- 公司简称 -->
              <el-form-item label="公司简称" :show-message="false" prop="tenantSimpleAddDTO.abbreviation">
                <el-input
                  clearable
                  :maxlength="50"
                  @blur="formData.tenantSimpleAddDTO.abbreviation = $event.target.value.replace(/\s/g, '')"
                  placeholder="最多输入50个字"
                  size="small"
                  min="0"
                  v-model="formData.tenantSimpleAddDTO.abbreviation"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">   
            <el-col :span="12">
              <!-- 公司成立时间 -->
              <el-form-item label="公司成立时间" :show-message="false">
                <el-date-picker
                  clearable
                  size="small"
                  placeholder="请选择企业创立时间"
                  value-format="yyyy-MM-dd"
                  v-model="formData.establishDate"
                ></el-date-picker>
              </el-form-item>
            </el-col>

            <!-- 账号类型 -->
            <el-col :span="12">
              <el-form-item label="账号类型" :show-message="false" prop="tenantSimpleAddDTO.memberStatus">
                <el-select
                  clearable
                  size="small"
                  filterable
                  v-model="formData.tenantSimpleAddDTO.memberStatus"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in getCodeListByKey('账号类型')"
                    :key="item.guid"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>   

          <el-row :gutter="24">   
            <!-- 公司组织形式 -->
            <el-col :span="12">
              <el-form-item label="公司组织形式">
                <el-select size="small" clearable filterable v-model="formData.organizationForm" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in getCodeListByKey('公司组织形式')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 注册资本(万元) -->
            <el-col :span="12">
              <el-form-item label="注册资本(万元)">
                <el-input
                  clearable
                  type="text"
                  :maxlength="12"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g, '$1')"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.registeredCapital"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">   
            <!-- 证照年审是否正常 -->
            <el-col :span="12">
              <el-form-item label="证照年审是否正常">
                <el-radio-group v-model="formData.annualReviewState">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <!-- 是否实缴 -->
            <el-col :span="12">
              <el-form-item label="是否实缴">
                <el-radio-group v-model="formData.isPaidIn">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">   
            <!-- 介绍人 -->
            <el-col :span="12">
              <el-form-item label="介绍人">
                <el-input
                  clearable
                  type="text"
                  :maxlength="10"
                  @blur="blurName(formData.introducer)"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.introducer"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 是否垫资 -->
            <el-col :span="12">
              <el-form-item label="是否垫资">
                <el-radio-group v-model="formData.isAdvanceMoney">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">   
            <!-- 介绍人电话 -->
            <el-col :span="12">
              <el-form-item label="介绍人电话">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  :maxlength="20"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.introducerTel"
                  @blur="formData.introducerTel = $event.target.value"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 税号 -->
            <el-col :span="12">
              <el-form-item label="税号" :show-message="false" prop="tenantSimpleAddDTO.taxpayerId">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9a-zA-Z]/g,'')"
                  @blur="formData.tenantSimpleAddDTO.taxpayerId = $event.target.value"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.tenantSimpleAddDTO.taxpayerId"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">   
             <!-- 服务商类型 -->
            <el-col :span="12">
              <el-form-item label="服务商类型" :show-message="false" prop="serviceProviderType">
                <el-select size="small" clearable filterable v-model="formData.serviceProviderType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in getCodeListByKey('服务商类型')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 服务费计算方式 -->
            <el-col :span="12">
              <el-form-item label="服务费计算方式"  :show-message="false" prop="settleAmountCalculateWay">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="formData.settleAmountCalculateWay"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in SettleAmountCalculateWayOptions"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <!-- 核算周期 -->
            <el-col :span="12" class="account-class">
              <el-form-item>
                <span slot="label">核算周期</span>
              </el-form-item>
              <div class="acountMountClass">
                <el-radio v-model="formData.accountCycle" label="自然月" @change="handleAccountCycleChange">自然月</el-radio>
                <div class="account-radio-class">
                  <el-radio v-model="formData.accountCycle" label="核算月" @change="handleAccountCycleChange">核算月，核算截止日为
                  </el-radio>
                  <el-input
                    style="width:80px"
                    size="small"
                    placeholder="1 ~ 31"
                    @input="formData.accountDeadline = formData.accountDeadline.replace(/[^\d\-\d]/g, '')"
                    v-model.trim="formData.accountDeadline"
                    maxlength="2"
                    :disabled="formData.accountCycle !== '核算月'"
                    @blur="accountDeadlineBlur"
                  >
                  </el-input>
                  <span style="color: red">
                    （示例：8月26日-9月25日，核算截止日填写 25）
                  </span>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 基础信息 -->

      <!-- start of 联系方式 -->
      <div class="back-color-fff form-box">
        <span class="form-title">联系方式</span>
        <div class="form-item-box">
          <el-row>
            <!-- 公司地址 -->
            <el-col :span="12">
              <el-form-item label="公司地址">
                <!-- <span slot="label" style="color: red; margin-right: 4px">*</span> -->
                <span slot="label">所在省市区 </span>
                <el-cascader
                  clearable
                  size="small"
                  ref="cascaderFirst"
                  style="width: 314px"
                  @change="incres"
                  filterable
                  :options="options"
                  v-model="addressList"
                >
                </el-cascader>
              </el-form-item>
            </el-col>

            <!-- 详细地址 -->
            <el-col :span="12">
              <el-form-item label="详细地址" :show-message="false" prop="tenantSimpleAddDTO.address">
                <el-input
                  clearable
                  type="text"
                  size="small"
                  style="width: 314px"
                  v-model="formData.tenantSimpleAddDTO.address"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- 业务联系人 -->
            <el-col :span="12">
              <el-form-item label="业务联系人" :show-message="false" prop="tenantSimpleAddDTO.contacts">
                <el-input
                  clearable
                  :maxlength="10"
                  placeholder="请填写"
                  size="small"
                  type="text"
                  @blur="blurName2(formData.tenantSimpleAddDTO.contacts)"
                  v-model="formData.tenantSimpleAddDTO.contacts"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 联系电话 -->
            <el-col :span="12">
              <el-form-item label="业务联系人电话" :show-message="false" prop="tenantSimpleAddDTO.contactTel">
                <el-input
                  clearable
                  type="text"
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  :maxlength="20"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.tenantSimpleAddDTO.contactTel"
                  @blur="formData.tenantSimpleAddDTO.contactTel = $event.target.value"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!-- 公司电话 -->
            <el-col :span="12">
              <el-form-item label="公司电话" :show-message="false" prop="tenantSimpleAddDTO.tel">
                <el-input
                  clearable
                  size="small"
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  v-model="formData.tenantSimpleAddDTO.tel"
                  @blur="formData.tenantSimpleAddDTO.tel = $event.target.value"
                  :maxlength="20"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系方式 -->

      <!-- start of 登录账号 -->
      <div class="back-color-fff form-box">
        <span class="form-title">登录账号</span>
        <div class="form-item-box">
          <el-row>
            <!-- 初始账号 -->
            <el-col :span="12">
              <el-form-item label="初始账号" prop="initUserName">
                <el-input
                  :disabled="guid ? true : false"
                  placeholder="请填写"
                  oninput="value=value.replace(/[^0-9]/g,'')"
                  @blur="formData.initUserName = $event.target.value"
                  size="small"
                  type="text"
                  v-model="formData.initUserName"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 初始角色 -->
            <el-col :span="12">
              <el-form-item label="初始角色">
                <el-input
                  disabled
                  type="text"
                  placeholder="请输入"
                  size="small"
                  v-model="formData.initRoleName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 联系方式 -->

      <!-- start of 开户行信息 -->
      <div class="back-color-fff form-box">
        <div style="position: relative">
          <span class="form-title">开户行信息</span>
          <el-popover trigger="hover" width="200" placement="top-start">
            <div>{{ '影响上下游结算时银行信息选择' }}</div>
            <template slot="reference">
              <i class="el-icon-question"></i>
            </template>
          </el-popover>
          <div class="sub-operate-add3">
            <el-button type="defalut" v-show="formData.bankList.length === 0" size="mini" @click="addBankItem"
              >新增</el-button
            >
          </div>
        </div>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title">
              <span>开户行信息{{ index + 1 }}</span>
              <div style="display: flex">
                <el-button
                  type="defalut"
                  size="mini"
                  v-show="item.guid && item.bizState === 'S'"
                  @click="enableBankItem(item, 'Y')"
                  >启用</el-button
                >
                <el-button
                  type="defalut"
                  size="mini"
                  v-show="item.guid && item.bizState === 'Y'"
                  @click="enableBankItem(item, 'S')"
                  >停用</el-button
                >
                <div style="position: relative">
                  <el-button
                    class="sub-operate-add2"
                    type="defalut"
                    size="mini"
                    v-show="index === 0"
                    @click="addBankItem"
                    >新增</el-button
                  >
                  <el-button
                    type="danger"
                    v-show="formData.bankList.length > 1"
                    size="mini"
                    @click="delBankItem(item, index)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-row>

          <el-row>
            <!-- 账户类型-->
            <el-col :span="12">
              <el-form-item label="账户类型" required>
                <el-select size="small" clearable :disabled="item.bizState==='S'" v-model="item.accountType" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in getCodeListByKey('账户类型')"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <!-- 开户银行 -->
            <el-col :span="12">
              <el-form-item label="开户银行" required>
                <el-input
                  type="text"
                  size="small"
                  :disabled="item.bizState==='S'"
                  v-model="item.bankName"
                  :maxlength="100"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户账号 -->
            <el-col :span="12">
              <el-form-item label="开户账号" required>
                <el-input
                  :ref="'bankAccountRef'+index"
                  size="small"
                  type="text"
                  :disabled="item.bizState==='S'" 
                  @input="onInput(index,$event)"
                  @blur="item.bankAccount = $event.target.value"
                  @click.native="checkBankAccount(item,$event)"
                  v-model="item.bankAccount"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户行号 -->
            <el-col :span="12">
              <el-form-item label="开户行号">
                <el-input
                  size="small"
                  type="text"
                  :disabled="item.bizState==='S'" 
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  @blur="item.bankNo = $event.target.value"
                  v-model="item.bankNo"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 开户行信息 -->

      <!-- start of 开票信息 -->
      <div class="back-color-fff form-box">
        <div style="position: relative">
          <span class="form-title">开票信息</span>
        </div>
        <div class="form-item-box" v-for="(item, index) in formData.bankList" :key="index">
          <el-row style="padding: 10px 35px">
            <div class="sub-title">
              <span>开票信息{{ index + 1 }}</span>
              <div style="display: flex">
                <div style="position: relative">
                  <el-button type="defalut" size="mini" @click="previewInvoice(item)">预览</el-button>
                </div>
              </div>
            </div>
          </el-row>

          <el-row>
            <!-- 发票抬头 -->
            <el-col :span="12">
              <el-form-item label="发票抬头">
                <el-input
                  type="text"
                  disabled
                  size="small"
                  v-model="formData.tenantSimpleAddDTO.tenantName"
                  :maxlength="100"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 税号 -->
            <el-col :span="12">
              <el-form-item label="税号">
                <el-input size="small" disabled v-model="formData.tenantSimpleAddDTO.taxpayerId"> </el-input>
              </el-form-item>
            </el-col>

            <!-- 开户银行 -->
            <el-col :span="12">
              <el-form-item label="开户银行">
                <el-input
                  type="text"
                  size="small"
                  disabled
                  v-model="item.bankName"
                  :maxlength="100"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 开户账号 -->
            <el-col :span="12">
              <el-form-item label="开户账号">
                <el-input
                  size="small"
                  disabled
                  type="text"
                  oninput="value=value.replace(/[^\d\s]/g, '')"
                  v-model="item.bankAccount"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>

            <!-- 电话号码 -->
            <el-col :span="12">
              <el-form-item label="公司电话">
                <el-input
                  size="small"
                  disabled
                  oninput="value=value.replace(/[^0-9-]/g,'')"
                  v-model="formData.tenantSimpleAddDTO.tel"
                  @blur="formData.tenantSimpleAddDTO.tel = $event.target.value"
                  :maxlength="20"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <!-- 单位地址 -->
            <el-col :span="12">
              <el-form-item label="单位地址">
                <el-input
                  type="text"
                  size="small"
                  disabled
                  style="width: 314px"
                  v-model="formData.tenantSimpleAddDTO.address"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- end of 开票信息 -->

      <!-- start of 证照信息 -->
      <div class="back-color-fff form-box">
        <span class="form-title">证照信息</span>
        <div class="form-item-box">
          <!-- 营业执照 -->
          <el-form-item label="营业执照">
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                accept=".jpg,.png,.jpeg,.pdf"
                :on-remove="removeBusinessList"
                :http-request="uploadBusinesslicense"
                :file-list="businesslicenseList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ '注意：支持jpg,png,jpeg,pdf，单个文件大小需 <= 20M' }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="businesslicenseList && businesslicenseList.length > 0">
                <a
                  :href="businesslicenseList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(businesslicenseList[0].path, businesslicenseList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(businesslicenseList[0], 'businesslicenseList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 完税证明 -->
          <el-form-item label="完税证明">
            <el-select size="small" clearable v-model="formData.taxPaymentCertificateDate" placeholder="请选择">
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>

            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removeTaxPaymentList"
                :http-request="uploadTaxPayment"
                :file-list="taxPaymentList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="taxPaymentList && taxPaymentList.length > 0">
                <a
                  :href="taxPaymentList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(taxPaymentList[0].path, taxPaymentList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(taxPaymentList[0], 'taxPaymentList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
          <!-- 个税扣缴明细 -->
          <el-form-item label="个税扣缴明细">
            <el-select size="small" clearable v-model="formData.privateTaxDetailDate" placeholder="请选择">
              <el-option v-for="(item, index) in monthsList" :key="index" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
            <div class="file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="1"
                :on-exceed="handleExceed"
                :accept="acceptFile"
                :on-remove="removePrivateTaxList"
                :http-request="uploadPrivateTax"
                :file-list="privateTaxList"
                :beforeUpload="beforeAvatarUpload"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传文件</el-button
                  >
                  <div slot="tip" class="import-step-tip">{{ tips }}</div>
                </div>
              </el-upload>

              <div class="btn-box" v-if="privateTaxList && privateTaxList.length > 0">
                <a
                  :href="privateTaxList[0].path + '?response-content-type=application/octet-stream'"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4"
                  download="FileName"
                  class="downFile"
                  >点击下载</a
                >
                <a
                  @click="seeDetail(privateTaxList[0].path, privateTaxList[0].name)"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >点击查看</a
                >
                <a
                  @click="handleMainRemove(privateTaxList[0], 'privateTaxList')"
                  style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                  download="FileName"
                  class="downFile"
                  >删除</a
                >
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <!-- end of 证照信息 -->

      <!-- start of 签约合同信息 -->
      <div class="back-color-fff form-box content-main-box" v-if="contractList.length">
        <span class="form-title">签约合同信息</span>
        <div class="back-color-fff form-box">
          <div class="form-item-box">
            <el-table
              ref="multipleTable"
              :data="contractList"
              :max-height="200"
              stripe
              border
              style="width: 100%"
              :row-key="(row) => row.guid"
            >
              <el-table-column label="序号" type="index" width="60" header-align="center" align="center" fixed="left">
              </el-table-column>
              <!-- 合同编号 -->
              <el-table-column
                prop="contractCode"
                min-width="180"
                label="合同编号"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 合同名称 -->
              <el-table-column
                prop="contractName"
                min-width="180"
                label="合同名称"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 甲方名称 -->
              <el-table-column
                prop="tenantName"
                min-width="210"
                label="甲方名称"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 乙方名称 -->
              <el-table-column
                prop="serviceTenantName"
                min-width="210"
                label="乙方名称"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
              </el-table-column>
              <!-- 签约日期 -->
              <el-table-column
                prop="signDate"
                min-width="160"
                label="签约日期"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.signDate | getDate }}
                </template>
              </el-table-column>
              <!-- 合同有效期 -->
              <el-table-column
                prop="validityDate"
                min-width="120"
                label="合同有效期"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span :style="{ color: getAlarmTime(scope.row.validityDate, 30) ? 'red' : '' }">
                    {{ scope.row.validityDate | getDate }}
                  </span>
                </template>
              </el-table-column>
              <!-- 收费比例(%) -->
              <el-table-column
                prop="chargeRate"
                min-width="120"
                label="收费比例(%)"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.chargeRate ? Number(scope.row.chargeRate).toFixed('2') : '-' }}
                </template>
              </el-table-column>
              <!-- 下发扣除税点(%) -->
              <el-table-column
                prop="sendTaxDeduction"
                min-width="120"
                label="下发扣除税点(%)"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.sendTaxDeduction ? Number(scope.row.sendTaxDeduction).toFixed('2') : '-' }}
                </template>
              </el-table-column>
              <!-- 合同类型 -->
              <el-table-column
                prop="contractType"
                min-width="120"
                label="合同类型"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ $getNameByKey(scope.row.contractType, '合同类型') }}
                </template>
              </el-table-column>
              <!-- 业务类型 -->
              <el-table-column
                prop="tenantName"
                min-width="96"
                label="业务类型"
                header-align="center"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.contractContentType | contractContentTypeFilter }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- end of 签约合同信息 -->

      <div class="submit-btn-box submit_btn_wrap">
        <el-button type="defalut" size="small" @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
      </div>
    </el-form>
    <!-- 发票信息 -->
    <InvoiceMessage :showInvoiceBox.sync="showInvoiceBox" :invoiceData="invoiceData"></InvoiceMessage>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import InvoiceMessage from './components/invoiceMessage.vue';
import { SettleAmountCalculateWayOptions } from './enum.js'
export default {
  components: {
    InvoiceMessage,
  },
  data() {
    return {
      SettleAmountCalculateWayOptions,
      guid: '',
      enterpriseCate: '9901',
      options: areaJson,
      addressList: [],
      address: [],
      contractList: [], // 合同列表
      detailAddres: '',
      showInvoiceBox: false, // 预览发票弹框
      invoiceData: {
        invoiceHeader: '',
        taxpayerId: '',
        address_tel: '',
        bankName_acount: '',
      },
      // 表单字段
      formData: {
        registeredCapital: '', // 注册资本
        initRoleName: '数据管理员',
        initUserName: '', // 初始账号
        establishDate: '', // 公司成立时间
        organizationForm: '', // 公司组织形式
        isPaidIn: '', // 是否实缴
        annualReviewState: '', // 证照年审状态
        cooperationTaxRate: '', // 合作税率
        cooperationValidityDate: '', // 合同有效期至
        monthMaxMoney: '', // 月度合作上限
        invoiceType: '', // 开票类型
        introducer: '', // 介绍人
        introducerTel: '', // 联系电话
        businessLicenseUrl: '', //营业执照路径
        taxPaymentCertificateDate: '', // 完税证明时段
        taxPaymentCertificateUrl: '', //完税证明路径
        privateTaxDetailDate: '', // 个税扣缴明细
        privateTaxDetailUrl: '', // 个税扣缴证明
        isCooperation: 'Y', // 是否合作
        serviceProviderType:'',//服务商类型
        accountCycle: '自然月', // 核算周期
        accountDeadline: '', // 核算截止日
        tenantSimpleAddDTO: {
          guid: '',
          tenantName: '', // 企业名称
          memberStatus: '', // 账号类型
          abbreviation: '', // 简称
          province: '',
          city: '',
          district: '',
          venue: '',
          tel: '',
          taxpayerId: '',
          address: '',
          contacts: '', // 业务联系人
          contactTel: '', // 业务联系人电话
          settleAmountCalculateWay: null,//服务费计算方式
        
        },
        expenseType: null,
        bankList: [
          {
            //开户行信息
            accountType: '',
            bankName: '',
            bankAccount: '',
            bankNo: '',
          },
        ],
      },
      // 表单验证规则
      formRules: {
        'tenantSimpleAddDTO.tenantName': [{ required: true, message: '公司名称必填', trigger: 'change' }],
        'tenantSimpleAddDTO.abbreviation': [{ required: true, message: '公司简称必填', trigger: 'change' }],
        'tenantSimpleAddDTO.memberStatus': [{ required: true, message: '账号类型必填', trigger: 'change' }],
        'tenantSimpleAddDTO.contacts': [{ required: true, message: '业务联系人必填', trigger: 'change' }],
        'tenantSimpleAddDTO.contactTel': [{ required: true, message: '业务联系人电话必填', trigger: 'change' }],
        'tenantSimpleAddDTO.tel': [{ required: true, message: '公司电话必填', trigger: 'change' }],
        'tenantSimpleAddDTO.address': [{ required: true, message: '详细地址必填', trigger: 'change' }],
        'tenantSimpleAddDTO.taxpayerId': [{ required: true, message: '税号必填', trigger: 'change' }],
        initUserName: [{ required: true, message: '初始账号必填', trigger: 'change' }],
        serviceProviderType: [{ required: true, message: '服务商类型必填', trigger: 'change' }],
        settleAmountCalculateWay: [{ required: true, message: '服务费计算方式必填', trigger: 'change' }],
      },
      // 企业下拉选数据
      tenantList: [],
      // 完税证明、个税扣缴明细下拉选数据
      monthsList: [
        {
          text: '近3个月',
          value: 3,
        },
        {
          text: '近6个月',
          value: 6,
        },
        {
          text: '近12个月',
          value: 12,
        },
      ],
      // acceptFile: '.xlsx,.xsl,.xls,.xlsm,.doc,.docx,.png,.jpg,.jpeg,.pdf',
      acceptFile: '*',
      tips: '注意：支持所有文件，单个文件大小需 <= 20M',
      // 营业执照文件
      businesslicenseList: [],
      // 完税证明文件
      taxPaymentList: [],
      // 个人扣缴明细文件
      privateTaxList: [],
    };
  },
  created() {
    // this.getTenantData(); // 获取企业接口
    // 修改时需要获取详情数据，给表单赋值
    if (this.$route.query.guid) {
      this.guid = this.$route.query.guid;
      this.getDetailData(this.guid, this.$route.query.tenantGuid);
    }
  },
  methods: {
    /**
     * 获取企业数据
     */
    getTenantData() {
      let that = this;
      that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, {
          // 企业分类(00 平台；0101 医药生产；010201 商业流通公司；010203 COS企业；9901 运营公司；9902 劳务公司；9903 代缴公司；9904 代征公司对应mf_enterprise_cate表中的值)
          enterpriseCate: '9901',
          pageIndex: 1,
          pageSize: -1,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            this.tenantList = res.data.data.records || [];
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 修改费用类型
     */
    expenseTypeChange(val) {
      // console.log(val)
      if (val == '1') {
        this.formData['levyEnterprise']['costMoney'] = null;
      }
      if (val == '2') {
        this.formData['levyEnterprise']['cooperationTaxRate'] = null;
      }
    },
    // todo 详情
    getDetailData(guid, tenantGuid) {
      let url = `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${guid}`;
      this.api.get(url).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || this.formData;
          // 获取合同
          // this.getContractData(datas['tenantGuid']);
          let tenantParam = {
            pageIndex: 1,
            pageSize: -1,
            tenantGuid: guid, // 甲方方企业GUID
            approveState: 'Y', // U不审批 N审批初始状态 Y已通过 R驳回 C撤销
          };
          let serviceTenantParam = {
            pageIndex: 1,
            pageSize: -1,
            serviceTenantGuid: guid, // 乙方方企业GUID
            approveState: 'Y', // U不审批 N审批初始状态 Y已通过 R驳回 C撤销
          };
          Promise.all([this.getContractPromise(tenantParam), this.getContractPromise(serviceTenantParam)]).then(
            ([res1, res2]) => {
              let arr = [...res1, ...res2];
              this.contractList = this.sortDataArray(arr, 'signDate');
            },
          );
          // 营业执照处理
          if (datas.tenantLicVOs && datas.tenantLicVOs.length != 0) {
            this.businesslicenseList = [];
            let tenantLicVOs = JSON.parse(datas.tenantLicVOs[0].pictContent);
            tenantLicVOs.forEach((item) => {
              this.businesslicenseList.push({
                name: item.name,
                url: item.url,
              });
              this.licenseGuid = datas.tenantLicVOs[0].guid;
            });
          } else {
            this.businesslicenseList = [];
            this.licenseGuid = '';
          }

          // 完税证明文件
          if (datas['taxPaymentCertificateUrl']) {
            let file = datas['taxPaymentCertificateUrl'].split('/');
            this.taxPaymentList = [
              {
                name: file[file.length - 1],
                path: datas['taxPaymentCertificateUrl'],
              },
            ];
          }

          // 个人扣缴明细文件
          if (datas['privateTaxDetailUrl']) {
            let file = datas['privateTaxDetailUrl'].split('/');
            this.privateTaxList = [
              {
                name: file[file.length - 1],
                path: datas['privateTaxDetailUrl'],
              },
            ];
          }

          //开户行信息
          if (datas.bankList && datas.bankList.length) {
            datas.bankList = datas.bankList;
          } else {
            let bankList = [
              {
                //开户行信息
                accountType: null,
                bankName: null,
                bankAccount: null,
                bankNo: null,
              },
            ];
            datas.bankList = bankList;
          }

          // 填充地址
          if (!datas.tenantSimpleAddDTO['province']) {
            this.addressList = [];
          } else {
            this.addressList = [
              datas.tenantSimpleAddDTO.province,
              datas.tenantSimpleAddDTO.city,
              datas.tenantSimpleAddDTO.district,
            ];
          }

          datas.initRoleName = '数据管理员';
          datas = {
            ...datas,
            accountDeadline: datas.accountDeadline || '',
            accountCycle: datas.accountCycle || '自然月',
          }
          this.$set(this, 'formData', datas);
          // console.log('-----------')
          console.log(this.formData);
        }
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      let that = this;
      let { formData } = this;
      const guid = formData.tenantSimpleAddDTO.guid;
      let postData = JSON.parse(JSON.stringify(formData));
      const type = guid ? 'update' : 'add';
      const DTOs = guid ? 'tenantLicUpdateDTOs' : 'tenantLicAddDTOs';
      const methodName = formData.guid ? 'put' : 'postJson';
      if (guid) postData.tenantSimpleUpdateDTO = postData.tenantSimpleAddDTO; // #区分新增和修改字段

      // 如果核算周期是核算月，那截止日必填
      if (postData.accountCycle == '核算月') {
        if (!postData.accountDeadline) {
          this.$message.error('请填写核算截止日');
          return;
        }
      }
      if (formData.accountCycle == '自然月') {
        // 核算周期是自然月，截止日为0
        postData.accountDeadline = '0';
      }

      //测试、正式用一个appSideGuid  2023-08-11改的
      postData.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
      postData.appSideGuid = '03cb364e04d894a44cdb94273abffa13';
      // if (this.enterpriseCate == '9901' && this.checkTestEnv()) {
      //   postData.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
      //   postData.appSideGuid = '13312e94ceb8eb986b2885445530add0';
      // } else {
      //   postData.platformGuid = '1e2409b7ef0b412c2bb84e38f8fe50ba';
      //   postData.appSideGuid = '03cb364e04d894a44cdb94273abffa13';
      // }

      if (this.formData.bankList.length > 0) {
        try {
          this.formData.bankList.forEach((item, index) => {
            if (!item.accountType) {
              throw new Error(`开户行信息${index + 1}-账户类型不能为空`);
            }
            if (!item.bankName) {
              throw new Error(`开户行信息${index + 1}-开户银行不能为空`);
            }
            if (!item.bankAccount) {
              throw new Error(`开户行信息${index + 1}-开户账号不能为空`);
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }

      if (this.businesslicenseList.length != 0) {
        postData[DTOs] = [
          {
            licenseNum: '0000',
            licenseType: '1',
            pictContent: JSON.stringify(this.businesslicenseList),
            isUnlimited: 'N',
            beginDate: '',
            endDate: '',
            guid: this.licenseGuid,
          },
        ];
      } else {
        postData[DTOs] = null;
      }

      // 重复银行卡提示
      let repetitionArr = this.findRepeatBank(this.formData.bankList); // todo 查找重复的开户账号
      if (repetitionArr.length) {
        let item = repetitionArr[0];
        this.$message.error(`新增开户账号:[${item.bankAccount}]不能重复，请确认!`);
        return;
      }

      this.$refs['formData'].validate((valid, error) => {
        if (valid) {
          that.api[methodName](
            `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/${type}`,
            postData,
          ).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('保存成功');
              that.$router.go(-1); // 返回上一页
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          if (Object.keys(error) && Object.keys(error).length) {
            Object.keys(error).forEach((item, index) => {
              if (error[item] && error[item][0] && index === 0) {
                let errorItem = error[item][0];
                this.$message.error(errorItem.message);
              }
            });
          }

          console.log('error submit!!');
          return false;
        }
      });
    },
    // todo 获取企业基础银行列表
    getBankList() {
      let { tenantGuid } = this.formData;
      let that = this;
      this.api
        .get(`/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${tenantGuid}`)
        .then((res) => {
          const { data } = res;
          if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let datas = data.data;
            //开户行信息
            if (datas.bankList && datas.bankList.length) {
              this.$set(this.formData, 'bankList', datas.bankList);
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    /**
     * 上传营业执照文件-导入
     */
    uploadBusinesslicense(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        console.log(status);
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.businesslicenseList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 营业执照路径赋值
          self.formData['businessLicenseUrl'] = res.data.data.data;
          return;
        }
        if (status == 2) {
          self.removeBusinessList();
        }
      });
    },
    /**
     * 上传完税证明文件-导入
     */
    uploadTaxPayment(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.taxPaymentList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 完税证明路径赋值
          self.formData['taxPaymentCertificateUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removeTaxPaymentList();
        }
      });
    },
    /**
     * 上传个人扣缴明细文件-导入
     */
    uploadPrivateTax(file) {
      let self = this;
      self.uploadData(file, function (status, res) {
        // status 1上传成功  2上传失败
        if (status == 1) {
          self.privateTaxList.push({
            name: file.file.name,
            path: res.data.data.data,
          });
          // 个人扣缴明细路径赋值
          self.formData['privateTaxDetailUrl'] = res.data.data.data;
        }
        if (status == 2) {
          self.removePrivateTaxList();
        }
      });
    },
    /**
     * 附件上传方法
     * @param {*} file
     * @param {*} fn
     */
    uploadData(file, fn) {
      let self = this;
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('fileName', file.file.name);
      self.api
        .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // 成功回调
            if (fn) fn(1, res);
            self.$message({
              message: '上传成功',
              type: 'success',
            });
          } else {
            // 失败回调
            if (fn) fn(2, res);
            self.$message.error('上传失败!');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 移除营业执照文件
     */
    removeBusinessList() {
      this.businesslicenseList = [];
      this.formData['businessLicenseUrl'] = '';
    },
    /**
     * 移除完税证明文件
     */
    removeTaxPaymentList() {
      this.taxPaymentList = [];
      this.formData['taxPaymentCertificateUrl'] = '';
    },
    /**
     * 移除个人扣缴明细文件
     */
    removePrivateTaxList() {
      this.privateTaxList = [];
      this.formData['privateTaxDetailUrl'] = '';
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    /**
     * 上传前校验
     */
    beforeAvatarUpload(file) {
      var fileSuffix = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1) : '';
      const isJPG =
        fileSuffix === 'xlsx' ||
        fileSuffix === 'xsl' ||
        fileSuffix === 'xls' ||
        fileSuffix === 'xlsm' ||
        fileSuffix === 'doc' ||
        fileSuffix === 'docx' ||
        fileSuffix === 'png' ||
        fileSuffix === 'jpeg' ||
        fileSuffix === 'jpg' ||
        fileSuffix === 'pdf';
      const isLt5M = file.size / 1024 / 1024 < 20;
      // if (!isJPG) {
      //   this.$message.error('文件格式不正确!');
      // }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过20MB!');
      }
      return isJPG && isLt5M;
    },
    /**
     * 查看文件
     * @param {*} url
     * @param {*} name 图片名称
     */
    seeDetail(url, name) {
      var fileSuffix = name ? name.substring(name.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(url, name);
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url));
    },
    //新增银行
    addBankItem() {
      this.formData['bankList'].push({
        accountType: null,
        bankName: null,
        bankAccount: null,
        bankNo: null,
      });
    },
    //删除银行
    //删除银行
    delBankItem(item, index) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (item.guid) {
          this.tableLoading = true;
          this.api.postJson(`/ms-customer-service/tenant-expand/tenant-bank/delete?guid=${item.guid}&enterpriseCate=${this.enterpriseCate}`).then((res) => {
            this.tableLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success('删除成功');
              this.getBankList();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.formData['bankList'].splice(index, 1);
        }
      });
    },
    // todo开户行信息启用/停用
    enableBankItem(item, type) {
      if (!item.guid) this.$message.error(`开户行信息不存在`);
      let req = {
        bizState: type,
        guid: item.guid,
      };
      this.fullscreenLoading = true;
      this.api
        .put(`/ms-customer-service/tenant-expand/tenant-bank/update-state?bizState=${type}&guid=${item.guid}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('修改成功');
            this.getBankList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    addressChange(val) {
      if (val && val.length) {
        this.formData.address = `${val.join('')}${this.formData.address || ''}`;
      }
    },
    // 核算周期切换事件
    handleAccountCycleChange(val) {
      if (val == '自然月') {
        this.formData.accountDeadline = '';
      }
    },
    // 核算截止日校验
    accountDeadlineBlur() {
      if (this.formData.accountDeadline < 1 || this.formData.accountDeadline > 31) {
        this.$message.error('核算截止日范围为1~31');
        this.formData.accountDeadline = '';
        return;
      } else if (this.formData.accountDeadline[0] == '0') {
        this.$message.error('核算截止日不能以0开头');
        this.formData.accountDeadline = '';
        return;
      }
    },
    checkPhone(item, value, key) {
      if (/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(value)) {
        item[key] = value;
      } else {
        item[key] = '';
      }
    },
    incres(area) {
      this.formData.tenantSimpleAddDTO.province = area[0];
      this.formData.tenantSimpleAddDTO.city = area[1];
      this.formData.tenantSimpleAddDTO.district = area[2];
      let venue = '';
      if (area) {
        if (area[0]) {
          venue = this.province(area[0]);
        }
        if (area[1]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]);
        }
        if (area[2]) {
          venue = this.province(area[0]) + '/' + this.city(area[1]) + '/' + this.district(area[2]);
        }
      }
      this.formData.tenantSimpleAddDTO.venue = venue;
    },
    province(val) {
      let pr = '';
      this.options.forEach(function (j) {
        if (j.value == val) {
          pr = j.label;
        }
      });
      return pr;
    },
    city(val) {
      let ci = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.value == val) {
              ci = j.label;
            }
          });
        }
      });
      return ci;
    },
    district(val) {
      let di = '';
      this.options.forEach(function (i) {
        if (i.children != null && i.children != '') {
          i.children.forEach(function (j) {
            if (j.children != null && j.children != '') {
              j.children.forEach(function (n) {
                if (n.value == val) {
                  di = n.label;
                }
              });
            }
          });
        }
      });
      return di;
    },

    /**
     *
     * 判断是否在某个时间点内
     * date 输入日期(new Date())
     * dayNum 天数
     */
    getAlarmTime(date, dayNum) {
      let flag = false;
      let contractTime = new Date(date).getTime();
      let currentTime = new Date().getTime();
      let alarmTime = dayNum * 1000 * 24 * 60 * 60;
      if (contractTime - currentTime <= alarmTime) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    // 查询合同列表
    getContractPromise(param) {
      return new Promise((resolve, reject) => {
        this.api.postJson(`/${serverConfig.msCustomerService}/contract/detail-by-tenant-new`, param).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // console.log(res.data)
            let contractList = res.data.data || [];
            resolve(contractList);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // todo 查找重复的银行
    findRepeatBank(list) {
      let deWeightArr = []; // 去重后的数组
      let repetitionArr = []; // 重复的数组
      list.forEach((item1) => {
        const check = deWeightArr.every((item2) => {
          return item1.bankAccount !== item2.bankAccount;
        });
        check ? deWeightArr.push(item1) : repetitionArr.push(item1);
      });
      console.log('重复的数据================>>>>>', repetitionArr);
      return repetitionArr;
    },
    blurName(value) {
      this.formData.introducer = this.$NameCheckBlur(this, value);
    },
    blurName2(value) {
      this.formData.tenantSimpleAddDTO.contacts = this.$NameCheckBlur(this, value);
    },
    // 预览发票
    previewInvoice(item) {
      this.showInvoiceBox = true;
      this.invoiceData.invoiceHeader = this.formData.tenantName;
      this.invoiceData.taxpayerId = this.formData.taxpayerId;
      this.invoiceData.address_tel = `${this.formData.address || ''} ${this.formData.tel || ''}`;
      this.invoiceData.bankName_acount = `${item.bankName || ''} ${item.bankAccount || ''}`;
    },
    checkProEnv() {
      return (
        location.href.indexOf('https://scm-operation.csyaoly.com') > -1 ||
        location.href.indexOf('https://scm-operation.cs4pl.com') > -1
      );
    },
    // checkTestEnv() {
    //   return (
    //     location.href.indexOf('https://scm-operation-test.csbr.cn') > -1 || location.href.indexOf('//localhost:') > -1
    //   );
    // },
    //对数据进行日期排序
    sortDataArray(dataArray, key) {
      const self = this;
      return dataArray.sort((a, b) => {
        return self.$moment(b[key]).unix() - self.$moment(a[key]).unix();
      });
    },
    handleMainRemove(file, key) {
      this[key].forEach((item, index) => {
        if (item.path == file.path) {
          this[key].splice(index, 1);
        }
      });
    },
     // 银行卡校验提醒
    checkBankAccount(item,$event) {
      if (item.bankAccount && item.guid) {
        this.api.get(`/${serverConfig.msCustomerService}/tenant-expand/tenant-bank/is-update?guid=${item.guid}&enterpriseCate=${this.enterpriseCate}`).then((res) => {
          if (res.data.code === '0000') {
              if (res.data.msg) {
                this.$confirm(res.data.msg, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {});
              }
            }
        });
      }
    },
    // 开户账号校验
    onInput(idx,event) { 
      const newValue = event; 
      const numericValue = newValue.replace(/\D/g, ''); // 仅保留数字 
      // 检查输入是否包含非数字字符 
      if (newValue !== numericValue) { 
        // 如果有非数字字符，则更新输入框的值为仅包含数字的值
        this.$set(this.formData.bankList[idx],'bankAccount',numericValue)
        //  this.inputValue = numericValue; 
        } else { 
          // 如果输入内容只包含数字，则保持输入框的当前值不变 
          this.$set(this.formData.bankList[idx],'bankAccount',newValue)
          // this.inputValue = newValue; 
        } 
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  padding-bottom: 60px;
  .title-box {
    border-top: 1px solid #e5e5e5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217, 217, 217, 1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .form-item-box {
      width: 90%;
      margin: 0 auto;
      padding-bottom: 15px;
    }
    // .el-col-12 {
    //   height: 50px;
    // }
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-input,
    .el-select {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-input {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px;
      text-align: center;
      border-top: 1px solid #e5e5e5;
    }
  }

  /deep/ .el-form-item__error {
    padding-top: 0px;
  }
  .el-button--primary {
    color: #ffffff;
  }

  .file-list-box {
    display: flex;
    // justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 32px;
    .upload-file-box {
      max-width: calc(100% - 132px - 16px);
    }
    .btn-box {
      position: absolute;
      width: 180px;
      margin-left: 16px;
      height: 32px;
      left: 430px;
    }
  }
}
/deep/ .el-upload__tip {
  line-height: 1;
  margin-top: 8px;
}
.sub-title {
  line-height: 28px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}
.content-main-box {
  height: 100%;
  max-height: 300px;
}
.sub-operate-add2 {
  position: absolute;
  right: 0px;
  top: -35px;
}
.sub-operate-add3 {
  position: absolute;
  right: 30px;
  top: 5px;
}
// 核算周期样式
.account-class {
  display: flex;
}
.acountMountClass {
  display: flex;
  flex-direction: column;
  margin-top: 13px;
}
.account-radio-class {
  width: 640px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
}
/deep/.el-select-dropdown .el-select-dropdown__item {
  color: #212121;
}
/deep/ .el-upload-list__item {
  // width
  max-width: 430px;
}
</style>
